
import Homepage from './homepage';
import './styles/App.css';
import Navbar from './navbar';
import Destination from './destination';
import {HashRouter as Router, Route, Routes } from 'react-router-dom';
import Crew from './crew';
import Technology from './technologies';




const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Homepage />}></Route>
        <Route path='/dest' element={<Destination/>}></Route>
        <Route path='/crew' element={<Crew />}></Route>
        <Route path="/tech" element={<Technology/>}></Route>
      </Routes>
   </Router>
  );
}
export default App;
